import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {Stream} from '@app/stream/models';

class StreamNode {
    expandable: boolean;
    name: string;
    level: number;
    parent: string;
    stream: Stream;
}

function transformer(node: Stream, level: number): StreamNode {
    const data = {
        expandable: !!node.children && node.children.length > 0,
        name: node.name,
        level: level,
        parent: node.parent,
        stream: node,
    };
    return Object.assign(new StreamNode(), data);
}

export class StreamTree {
    public treeControl: FlatTreeControl<StreamNode>;
    public dataSource: MatTreeFlatDataSource<any, any>;
    private readonly treeFlattener: MatTreeFlattener<any, any>;

    constructor() {
        this.treeControl = new FlatTreeControl<StreamNode>(
            (node) => node.level,
            (node) => node.expandable,
        );
        this.treeFlattener = new MatTreeFlattener<any, any>(
            transformer,
            (node) => node.level,
            (node) => node.expandable,
            (node) => node.children,
        );
        this.dataSource = new MatTreeFlatDataSource<any, any>(this.treeControl, this.treeFlattener);
    }
}
